import {IApiProviderProto, space} from "../provider_api";
import IPractitionerProto = space.kenko.proto.IPractitionerProto;
import BusinessSubscriptionType = space.kenko.proto.BusinessSubscriptionType;
import ContactMethodType = space.kenko.proto.ContactMethodType;
import IBusinessSubscriptionProto = space.kenko.proto.IBusinessSubscriptionProto;

export const getPractitionerName = (provider: IPractitionerProto | null | undefined) => {
  if (!provider) {
    return '[none]'
  }

  if (!provider.firstName && !provider.lastName) {
    return '[name unset]'
  }

  return `${provider.firstName} ${provider.lastName}`;
}

export const subscriptionIdToString = (id: BusinessSubscriptionType | null | undefined) => {
  switch (id) {
    case BusinessSubscriptionType.LISTING:
      return 'Starter';
    case BusinessSubscriptionType.LISTING_PLUS_BOOKING:
      return 'Growth';
    default:
      return '';
  }
}

export const pluralize = (count: number | null | undefined) => {
  if (count == null) {
    return '';
  }
  
  return count == 1 ? '' : 's';
}

export const activeSubscriptionToString = (sub: IBusinessSubscriptionProto | null | undefined) => {
  return subscriptionToString(sub?.type, sub?.quantity);
}

const subscriptionToString = (type: BusinessSubscriptionType | null | undefined, quantity: number | null | undefined) => {
  if (!type || quantity == null) {
    return;
  }

  switch (type) {
    case BusinessSubscriptionType.LISTING:
      return `Kensu Starter for ${quantity} location${pluralize(quantity)}`;
    case BusinessSubscriptionType.LISTING_PLUS_BOOKING:
      return `Kensu Growth for ${quantity} practitioner${pluralize(quantity)}`;
    default:
      return '[no selection has been made]';
  }
}

export const isProviderEmailVerified = (provider: IApiProviderProto | null | undefined,
                                        email: string | null | undefined) => {
  return isProviderContactMethodVerified(provider, ContactMethodType.EMAIL, email);
}

export const isProviderMobileNumberVerified = (provider: IApiProviderProto | null | undefined,
                                               email: string | null | undefined) => {
  return isProviderContactMethodVerified(provider, ContactMethodType.MOBILE_PHONE, email);
}

const isProviderContactMethodVerified = (provider: IApiProviderProto | null | undefined,
                                         type: ContactMethodType,
                                         emailOrPhone: string | null | undefined) => {

  if (!provider || !emailOrPhone || !provider.verifiedContactMethods) {
    return false;
  }

  for (let i = 0; i < provider.verifiedContactMethods.length; i++) {
    const existing = provider.verifiedContactMethods[i];
    if (existing.contactMethod?.type == type &&
        existing.contactMethod.address == emailOrPhone) {
      return true;
    }
  }

  return false;
}

// pick the select value from the options. the client just passes in the value
// string but this API demands both the value and the label
export const findDefaultValue = <T extends any>(options: {label: string, value: T}[],
                                 v: T | null | undefined) => {

  if (!v || !options) {
    return null;
  }

  for (let i = 0; i < options.length; i++) {
    if (options[i].value == v) {
      return options[i];
    }
  }

  return null;
}
